<template>
  <span class="intent-score-badge" :class="scoreClass">
    {{ score }}%
  </span>
</template>

<script>
export default {
  name: 'IntentScoreBadge',
  props: {
    score: {
      type: null,
      required: true,
    },
  },
  computed: {
    scoreClass() {
      if (this.score < 50) {
        return 'low-score';
      } else if (this.score >= 50 && this.score < 70) {
        return 'medium-score';
      } else {
        return 'high-score';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.intent-score-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;
  min-width: 45px;
  text-align: center;

  &.low-score {
    background-color: #f8d7da;
    color: #721c24;
  }

  &.medium-score {
    background-color: #fff3cd;
    color: #856404;
  }

  &.high-score {
    background-color: #d4edda;
    color: #155724;
  }
}
</style>
